module.exports = __webpack_public_path__ + "img/nav-2.840d97bb.png";